<template>
  <div class="view-content">
    <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="名称:" prop="searchName">
          <el-input v-model="search.searchName" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="handleReset" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tools-box">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="handAdd"
        >添加二维码</el-button
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      max-height="600"
      size="small"
      :header-cell-style="{
        background: '#f5f5f5',
        color: '#000',
        fontWeight: 'bold',
        align: 'center',
      }"
    >
      <el-table-column
        prop="qrName"
        label="二维码名称"
        width="180"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="qrCodeNo"
        label="二维码编号"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="qrCodeUrl"
        label="二维码链接"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <div class="qr-wrapper">
            <el-image
              :src="scope.row.qrCodeUrl"
              class="qr-thumb"
              fit="cover"
              :preview-src-list="[scope.row.qrCodeUrl]"
              :z-index="9999"
            />
            <el-tooltip content="下载二维码" placement="top">
              <i
                class="el-icon-download download-btn"
                @click.stop="
                  downloadQrCode(scope.row.qrCodeUrl, scope.row.qrName)
                "
              ></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="itemName"
        label="推广类目"
        width="150"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column prop="scanTotal" label="总扫码次数" align="center">
      </el-table-column>

      <el-table-column prop="newCustomerNum" label="新增客户" align="center">
      </el-table-column>

      <el-table-column prop="orderTotal" label="成交订单数" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status == 1"> 启用 </el-tag>
          <el-tag type="success" v-if="scope.row.status == 0"> 停用 </el-tag>
          <el-tag type="dangerde" v-if="scope.row.status == 2"> 删除 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="areaName"
        label="服务区域"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="itemName"
        label="服务项目"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="220" align="center">
        <template slot-scope="scope">
          <span
            class="el-icon-edit table-btn btn-success"
            @click="handleEdit(scope.row)"
          >
            编辑
          </span>
          <!-- <span
            class="el-icon-lock table-btn btn-default"
            @click="handleDetail(scope.row)"
          >
            冻结
          </span>
          <span
            class="el-icon-refresh-left table-btn btn-default"
            @click="handleStatus(scope.row)"
          >
            恢复
          </span> -->
          <span
            class="el-icon-delete table-btn btn-normal"
            @click="handleStatus(scope.row)"
          >
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="search.pageIndex"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="480px"
      :close-on-click-modal="false"
      @closed="dialogCancel('nodeForm')"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="nodeForm"
        label-width="100px"
        size="small"
      >
        <el-form-item label="二维码名称" prop="qrName">
          <el-input v-model="formData.qrName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="推广类目" prop="bindCategoryId">
          <el-radio-group
            v-model="formData.bindCategoryId"
            :disabled="type == 'edit'"
          >
            <el-radio :label="0">全部服务</el-radio>
            <el-radio :label="1">指定服务</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="服务区域"
          prop="areaId"
          v-if="type == 'add' && formData.bindCategoryId == 1"
        >
          <el-cascader
            v-model="formData.areaId"
            :options="areaList"
            :props="{
              value: 'areaId',
              label: 'areaName',
              children: 'childrenCity',
            }"
            placeholder="请选择服务区域"
            style="width: 100%"
            ref="areaCascader"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="服务技能"
          prop="categoryId"
          v-if="type == 'add' && formData.bindCategoryId == 1"
        >
          <el-cascader
            v-model="formData.categoryId"
            :options="categoryList"
            :props="{
              value: 'categoryId',
              label: 'categoryName',
              children: 'childrenServiceItem',
            }"
            placeholder="请选择服务区域"
            style="width: 100%"
          ></el-cascader>
        </el-form-item>
        <el-form-item
          label="服务项目"
          prop="serviceId"
          v-if="type == 'add' && formData.bindCategoryId == 1"
        >
          <el-select
            v-model="formData.serviceId"
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in serviceList"
              :key="item.serviceId"
              :label="item.itemName"
              :value="item.serviceId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推广logo" prop="logoUrl">
          <Upload
            :imgUrl="formData.logoUrl || ''"
            @backUrl="(data) => backUrl(data)"
            @deleteImg="removeBusinessLicense()"
            v-if="type == 'add'"
          ></Upload>
          <div class="img-box" v-else>
            <el-image
              style="width: 100px; height: 100px"
              :src="formData.qrCodeUrl"
              :preview-src-list="[formData.qrCodeUrl]"
            >
            </el-image>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogCancel('nodeForm')"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  QueryAreaList,
  ModifyChannelQr,
  GetChannelQrList,
  LogoutChannelQrcode,
  QrcodeGenerate,
  AddQrcode,
  GetServiceItemAllList,
} from "@/api/codeManage/index";
import Upload from "./components/Upload.vue";
export default {
  components: { Upload },
  data() {
    return {
      search: {
        searchName: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      serviceList: [],
      categoryList: [],
      areaList: [],
      formData: {
        qrName: null,
        bindCategoryId: 0,
        areaName: "",
        logoUrl: null,
        serviceId: null,
        areaId: [],
        categoryId: [],
      },
      formRules: {},
      dialogVisible: false,
      dialogTitle: "添加二维码",
      type: "add",
    };
  },
  watch: {
    "formData.areaId": {
      handler() {
        if (this.type == "add") {
          this.getServiceList();
        }
      },
      deep: true,
    },
    "formData.categoryId": {
      handler() {
        if (this.type == "add") {
          this.getServiceList();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getTableData();
    // this.getServiceList();
    this.getCategoryList();
    this.getAreaList();
  },
  methods: {
    // 下载二维码
    downloadQrCode(url) {
      if (!url) {
        this.$message.warning("二维码链接不存在");
        return;
      }
      window.open(url, "_blank");
    },
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1; // 搜索时重置页码
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    backUrl(data) {
      this.$set(this.formData, "logoUrl", data);
    },
    removeBusinessLicense() {
      this.$confirm(`确定要删除吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$set(this.formData, "logoUrl", "");
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },

    getServiceList() {
      let categoryId = this.formData.categoryId.length
        ? this.formData.categoryId[this.formData.categoryId.length - 1]
        : null;
      let areaId =
        this.formData.areaId.length > 0
          ? this.formData.areaId[this.formData.areaId.length - 1]
          : null;
      GetServiceItemAllList({
        categoryId: categoryId,
        areaId: areaId,
        pageIndex: 1,
        pageSize: 10,
      }).then((res) => {
        if (res.data.isSuccess) {
          this.serviceList = res.data.data || [];
        }
      });
    },
    getCategoryList() {
      QrcodeGenerate().then((res) => {
        if (res.data.isSuccess) {
          this.categoryList = res.data.data || [];
        }
      });
    },
    getAreaList() {
      QueryAreaList().then((res) => {
        if (res.data.isSuccess) {
          this.areaList = res.data.data || [];
        }
      });
    },
    handAdd() {
      this.type = "add";
      this.dialogTitle = "添加";
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.type = "edit";
      this.dialogTitle = "修改";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.formData = JSON.parse(JSON.stringify(row));
      });
    },
    async handleStatus(row) {
      let message = await this.$message
        .delConfirm(`<p style="font-size:17px">确定删除吗？</p>
        <p style=" color: #7e7b7b;">删除后不可恢复!</p>`);
      if (message) {
        let params = { qrId: row.qrId, status: 2 };
        LogoutChannelQrcode(params).then((res) => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
            this.handleSearch();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    handleReset() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSearch() {
      this.search.pageIndex = 1; // 搜索时重置页码
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    // 获取表格数据
    getTableData() {
      GetChannelQrList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
    dialogCancel(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    submitForm() {
      this.$refs.nodeForm.validate((valid) => {
        if (valid) {
          if (this.type == "add") {
            if (this.formData.bindCategoryId == 1) {
              this.formData.areaName =
                this.$refs.areaCascader.getCheckedNodes()[0]?.label || "";
            } else {
              this.formData.areaName = "";
            }
            AddQrcode(this.formData).then((res) => {
              if (res.data.isSuccess) {
                this.$message.success(res.data.message);
                this.dialogVisible = false;
                this.handleSearch();
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            ModifyChannelQr({
              qrId: this.formData.qrId,
              qrName: this.formData.qrName,
            }).then((res) => {
              if (res.data.isSuccess) {
                this.$message.success(res.data.message);
                this.dialogVisible = false;
                this.handleSearch();
              } else {
                this.$message.error(res.data.message);
              }
            });
          }
        }
      });
    },
  },
};
</script>
<style scoped>
.img-box {
  width: 130px;
  height: 130px;
}
.qr-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.qr-thumb {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: 1px solid #e8eaed;
  cursor: pointer;
  flex-shrink: 0;
}

.qr-thumb .el-image__inner {
  border-radius: 4px;
}

.download-btn {
  font-size: 16px;
  color: #909399;
  cursor: pointer;
  transition: color 0.2s;
  flex-shrink: 0;
}

.download-btn:hover {
  color: #409eff;
}
</style>
